/* global $ */
(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller(
      "cancelConnectRequestController",
      cancelConnectRequestController,
    );

  cancelConnectRequestController.$inject = [
    "$uibModalInstance",
    "$scope",
    "connectRequestId",
    "UsersApi",
    "ConnectRequestsApi",
    "alerts",
  ];

  function cancelConnectRequestController(
    $uibModalInstance,
    $scope,
    connectRequestId,
    UsersApi,
    ConnectRequestsApi,
    alerts,
  ) {
    var vm = this;

    // properties
    vm.user = null;
    vm.isLoading = false;

    // methods
    vm.close = $uibModalInstance.close;
    vm.cancel = cancel;

    /**
     * cancels the connection request to the API
     * @return {void}
     */
    function cancel() {
      vm.isLoadingMessage = "Canceling request...";
      vm.isLoading = true;
      ConnectRequestsApi.delete(
        { id: connectRequestId },
        function handleConnectResponse(response) {
          vm.isLoading = false;
          alerts.emit({
            theme: "success",
            title: "Request Deleted",
            messages: [],
          });
          $uibModalInstance.close(response);
        },
        function handleConnectError() {
          vm.isLoading = false;
          vm.forceClose = true;
          $uibModalInstance.dismiss();
        },
      );
    }

    $scope.$on("modal.closing", function (event, reason, closed) {
      if (!closed && !vm.forceClose) {
        return event.preventDefault();
      }
    });
  }
})(angular);
